<template>
  <div>
    <div class="d-flex align-items-center mb-4">
      <h2>{{ $t('perfil.meusdados') }}</h2>
      <span class="barra-tit flex-fill"></span>
    </div>

    <div class="box-meus-dados">
      <b-tabs pills nav-class="nav-justified align-items-center">
        <b-tab active :title="$t('perfil.dadosacesso')">
          <dados-acesso :aluno="aluno" />
        </b-tab>
        <b-tab :title="$t('perfil.dadospessoais')">
          <dados-pessoais :aluno="aluno" />
        </b-tab>
        <b-tab v-if="$empresaUtils.temAcesso($tipoAcesso.PERFIL_MEUS_DADOS_ACADEMICOS.nome, $configEmpresa.rotasRestritasAcesso)" :title="$t('perfil.dadosacademicos')">
          <dados-faculdade :aluno="aluno" />
        </b-tab>
      </b-tabs>
    </div>

  </div>
</template>

<script>
import DadosAcesso from '@/modules/Perfil/components/meus-dados/DadosAcesso'
import DadosPessoais from '@/modules/Perfil/components/meus-dados/DadosPessoais'
import DadosFaculdade from '@/modules/Perfil/components/meus-dados/DadosFaculdade'

export default {
  name: 'MeusDadosPerfil',
  components: { DadosFaculdade, DadosPessoais, DadosAcesso },
  props: {
    aluno: Object
  }
}
</script>

<style scoped>

</style>
